var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container full-width"},[_c('div',{staticClass:"text-subtitle1"},[_vm._v("Promotion code")]),_c('q-input',{staticClass:"bg-white",attrs:{"debounce":"200","value":_vm.text,"placeholder":"Enter promotion code","dense":"","outlined":"","clearable":""},on:{"input":_vm.onChange,"blur":_vm.onBlur}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }